import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import GoogleLoginButton from './GoogleLoginButton';
import { useAuth } from './AuthContext';
import './Auth.css';

function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await axios.post('/auth/login', {
        email,
        password,
      });

      // Save user + token
      login(res.data.user, res.data.token);

      navigate('/chat');

    } catch (err) {
      setError(
        err.response?.data?.error ||
        'Invalid email or password (ভুল ইমেল বা পাসওয়ার্ড)'
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1>Login (লগইন)</h1>
        <p>Welcome back to REACH (REACH-এ আবার স্বাগতম)</p>

        {error && <div className="auth-error">{error}</div>}

        <form onSubmit={handleSubmit} noValidate>
          <input
            type="email"
            placeholder="Email (ইমেল)"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="password"
            placeholder="Password (পাসওয়ার্ড)"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? "Logging in..." : "Login (লগইন)"}
          </button>
        </form>

        <div className="divider">OR (অথবা)</div>

        <GoogleLoginButton />

        <p className="auth-footer">
          Don’t have an account? (অ্যাকাউন্ট নেই?){' '}
          <Link to="/register">Sign up (নিবন্ধন করুন)</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
